import React, { useEffect } from 'react'
import CrystalSandBanner from '../assets/Videos/CRYSTAL SAND (5.74 MB).mp4'
import '../css/crystal.css'
import '../css/MediaQueries/MediaQueryCrystalSand.css'
import { Helmet } from 'react-helmet'
import CrystalDifference from './CrystalDifference'
import CrystalBannerFallback from '../assets/Images/CrystalBannerFrame.jpg'
export default function CrystalSandPage () {
  useEffect(() => {
    // Scroll to top when the component is mounted
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className='crystal-sand'>
      <Helmet>
        <title>
          Best aggregates and Crystal sand Manufacturer | Endula Infra
        </title>
        <meta
          name='description'
          content='Endula Infra is your go-to manufacturer for superior aggregates and crystal sand, offering the finest materials to bring purity and excellence to every build.'
        />
      </Helmet>
      <div className='fac-hero'>
        <div className='heading-wrap fac'>
          <h1
            className='hero-heading'
            style={{ opacity: 1 }}
            words-slide-up=''
            text-split=''
          >
            Crystal Sand
          </h1>
        </div>
        <div
          className='arrows-trigger fac'
          style={{
            transform:
              'translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
            transformStyle: 'preserve-3d'
          }}
        ></div>
        <div className='background-noise-new'></div>
        <div className='hero-gradient'></div>
        <div className='video-fac w-background-video w-background-video-atom flex justify-center items-center'>
          <video
            autoPlay
            loop
            muted
            playsInline
            poster={CrystalBannerFallback}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          >
            <source src={CrystalSandBanner}  type='video/mp4' />
            Your browser does not support the video tag.
            <img src={CrystalBannerFallback} alt="About Banner Fallback" />
          </video>
        </div>
        <div className='section-anim-trigger'></div>
      </div>
      <section className='section-spacer fac-video'></section>
    <div className='section-wrap email'>
  <section className='section email about-section'>
    <div className='section-cont email px-4 py-10 w-[80%] mx-auto'>
      {/* First Row: Heading and First Para */}
      <div className='grid grid-cols-1 md:grid-cols-2 gap-8 mb-10 items-center'>
        <h2 className='h3-heading research text-3xl md:text-4xl font-bold'>
          The Future of <br/> Sand is here
        </h2>
        <div className='email-heading forSameFonts text-base md:text-lg leading-relaxed'>
          Until now, river sand was the only kind of sand used for construction activities as it was very economical and abundantly available hence, it was over-utilized. But these days, it’s very difficult to get good quality sand at short distances from developing cities.
          <p className='mt-3'>
            Therefore, we came up with our unique idea of Crystal sands which is environmentally friendly yet economical.
          </p>
        </div>
      </div>

      {/* Second Row: Two More Paragraphs */}
      <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
        <div className='text-20px email forSameFonts text-base md:text-lg leading-relaxed'>
          The phenomenal growth in the construction industry over the last decade has contributed to a wide gap between the supply and demand of natural sand. In the process, a lot of damage has been caused to eco-systems by dredging sand from river beds leading to the depletion of water ground levels in the various parts of the country. This situation created a great need for manufactured sand as a replacement for river sand.
        </div>
        <div className='text-20px email last forSameFonts text-base md:text-lg leading-relaxed'>
          Across the world, there is growing support for the use of manufactured sand, especially in the production of concrete. Structural Engineers and construction technologists highly recommend manufactured sand for its perfect particle shape, consistent gradation, and zero impurities. This sand also eliminates other constraints of river sand, like availability and price fluctuation. This is the future of sand as we know it. Welcome to the Future.
        </div>
      </div>
    </div>

    <div className='section-anim-trigger'></div>
  </section>
</div>

      <div className='section-spacer email'></div>
      <div className='section-wrap programs'>
        <section className='section program'>
          <div className='section-cont program'>
            <div className='benefits-heading'>
              <h2>Benefits of Crystal Sand</h2>
            </div>
            <CrystalDifference />
            <div className='parallax-anim-trigger'></div>
          </div>
        </section>
      </div>
      <section className='section-spacer programs'></section>
      <div className='section-wrap-1 people'>
        <section className='section people'>
          <div className='section-cont people'>
            <div
              className='people-heading people heading-font '
              style={{
                transform:
                  'translate3d(0px, 0vw, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                transformStyle: 'preserve-3d',
                opacity: 1
              }}
            >
              Why Crystal Sand?
            </div>
            <div
              className='people-section-descr science people forSameFonts'
              style={{
                transform:
                  'translate3d(0px, 0vw, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                transformStyle: 'preserve-3d',
                opacity: 1
              }}
            >
              Crystal Sand conforms to the standards outlined in ‘Vastu Shastra,’ as it is free from impurities such as bones, river shells, and other organic materials. This purity promotes happiness, prosperity, and peace for the owners and residents of buildings constructed with Crystal Sand. Additionally, its clean surface area reduces the need for excessive cement consumption and no additives are required.
            </div>
          </div>
        </section>
      </div>
      <section className='section-spacer people'></section>
    </div>
  )
}
